module.exports = __webpack_public_path__ + "static/media/superdefense_daily_image.fb59d459.png";